import { useTranslation } from 'react-i18next';
import yarmisImage from '../assets/yarmis.3.webp';





// Mapeo de iconos SVG para mantener el orden con las features traducidas


const Features = () => {
  const { t } = useTranslation();

  // Obtiene las features traducidas
  const features = t('features.cards', { returnObjects: true });
  // Asegura que cada feature tenga el icono y el flag de botón si corresponde
  const featuresWithIcons = features.map((feature, idx) => ({
    ...feature,
    id: idx + 1,

  }));

  

  return (
    <section className="text-center" id="features">
      {/* Título de la sección */}
      <div className="divider-conteiner text-center space-y-0 mb:space-y-2">
        <h1 className="font-sans text-secondary font-bold resp-h3">
          {t('features.section_title')}
        </h1>
        <p className="hero-p resp-h2" style={{ lineHeight: "130%" }}>
          {t('features.section_subtitle')}
        </p>
      </div>
          
        
      {/* Espaciado vertical entre título y tarjetas */}
      <div style={{ paddingTop: "60px" }}>
        {/* Sección de tarjetas */}
        <div className="flex flex-col p-8 mb:py-4 mb:px-0 mx-16 mb:mx-8 mb:space-y-2">
          <div className="ft-list flex justify-center w-full">
            <div className="ft-grid max-w-6xl mx-auto px-4" style={{ alignItems: 'stretch' }}>
              {featuresWithIcons.map((feature) => (
                <div key={feature.id} className="tags" style={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                  
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <h3
                      className="font-archivo ft-title"
                      style={{ lineHeight: "120%" }}
                    >
                      {feature.title}
                    </h3>
                    <p className="text-[14px] text-secondary text-content ft-p break-words mb-4" style={{ flex: 1 }}>
                      {feature.description}
                    </p>
                    
                  </div>
                </div>
              ))}
              
              {/* Tarjeta adicional con imagen Yarmis - transparente */}
              <div 
                className="flex items-center justify-center" 
                style={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  
                }}
              >
                <img 
                  src={yarmisImage} 
                  alt="Yarmis" 
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      

      {/* Overlay Flashcard */}
      
    </section>
  );
};

export default Features;